import { CoreConfig } from "@core/types";

/**
 * Default App Config
 *
 * ? TIP:
 *
 * Change app config based on your preferences.
 * You can also change them on each component basis. i.e `app/main/pages/authentication/auth-login-v1/auth-login-v1.component.ts`
 *
 * ! IMPORTANT: If the enableLocalStorage option is true then make sure you clear the browser local storage(https://developers.google.com/web/tools/chrome-devtools/storage/localstorage#delete).
 *  ! Otherwise, it will not take the below config changes and use stored config from local storage.
 *
 */

// prettier-ignore
export const coreConfig: CoreConfig = {
  app: {
    appName: 'WeTeam',                                        // App Name
    appTitle: 'WeTeam - Inside your future',                  // App Title
    appIconImage: 'assets/images/logo/nepta-icon.svg',
    appLogoImage: 'assets/images/logo/nepta.svg',            // App Logo
    appLanguage: 'it',                                       // App Default Language (en, fr, de, pt etc..)
  },
  layout: {
    skin: 'default',                        // default, dark, bordered, semi-dark
    type: 'vertical',                       // vertical, horizontal
    animation: 'fadeIn',                     // fadeInLeft, zoomIn , fadeIn, none
    menu: {
      hidden: false,           // Boolean: true, false
      collapsed: false,           // Boolean: true, false
    },
    // ? For horizontal menu, navbar type will work for navMenu type
    navbar: {
      hidden: false,           // Boolean: true, false
      type: 'floating-nav',  // navbar-static-top, fixed-top, floating-nav, d-none
      background: 'navbar-light',  // navbar-light. navbar-dark
      customBackgroundColor: true,            // Boolean: true, false
      backgroundColor: '',               // BS color i.e bg-primary, bg-success
    },
    footer: {
      hidden: false,           // Boolean: true, false
      type: 'footer-static', // footer-static, footer-sticky, d-none
      background: 'footer-light',  // footer-light. footer-dark
      customBackgroundColor: false,           // Boolean: true, false
      backgroundColor: '',               // BS color i.e bg-primary, bg-success
    },
    languageSelector: false,
    enableLocalStorage: true,
    customizer: false,                       // Boolean: true, false (Enable theme customizer)
    scrollTop: false,                       // Boolean: true, false (Enable scroll to top button)
    buyNow: false,                        // Boolean: true, false (Set false in real project, For demo purpose only)
  },
  custom: {
    corporate_name: 'Nepta',
    email_domain: '@nepta.it',
    enable_gamification: false,
    user_available_socials: ['facebook', 'linkedin', 'twitter', 'instagram'],
    working_days: [1, 2, 3, 4, 5], //Working days for the monthly report
    set_retroactive_date_commission: false,
    document_id_types: [
      {
        name: 'Patente',
        value: 'patente',
      },
      {
        name: 'Passaporto',
        value: 'passaporto',
      },
      {
        name: "Carta d'Identità",
        value: 'carta-didentita',
      },
    ],
    user_report_max_day: {
      0: 20, // per gennaio
      1: 20, // per febbraio
      2: 20, // per marzo
      3: 20, // per aprile
      4: 20, // per maggio
      5: 20, // per giugno
      6: 20, // per luglio
      7: 20, // per agosto
      8: 20, // per settembre
      9: 20, // per ottobre
      10: 20, // per novembre
      11: 15, // per dicembre
    },
  },
};
